/** Rounded speech bubble with a centred (direction-neutral) tail under it. */
export function bubble(x: number, y: number, w: number, h: number, r = 12): string {
  const m = x + w / 2;
  const b = y + h;
  return (
    `M${x + r} ${y}H${x + w - r}Q${x + w} ${y} ${x + w} ${y + r}V${b - r}` +
    `Q${x + w} ${b} ${x + w - r} ${b}H${m + 7}L${m} ${b + 9}L${m - 7} ${b}H${x + r}` +
    `Q${x} ${b} ${x} ${b - r}V${y + r}Q${x} ${y} ${x + r} ${y}Z`
  );
}

/** Five-point star centred on the origin (radius 10). */
export const STAR = "M0-10L3-3H10L4.5 1.5 6.5 9 0 4.5-6.5 9-4.5 1.5-10-3H-3Z";
